// extracted by mini-css-extract-plugin
export default {"defaultLine":"#2f5be7","defaultFill":"#d9e5ff","grid":"#e7edf6","dotStroke":"#fff","skeletonOverlay":"zpsP5cAPgROGbZ8k07Pr","sparklineSkeletonShimmer":"vYGxadG1Ss26rNxiCqem"};